<template>
  <div class="upper-limb-orthosisW-step-two">
    <v-textarea
      v-model="form.comments"
      filled
      name="Commentaires :"
      label="Commentaires :"
    />
    <v-textarea
      v-model="form.part_to_order"
      filled
      name="Pièces à commander :"
      label="Pièces à commander :"
    />
    <v-layout
      justify-space-between
      mt-8
    >
      <v-flex
        column
        sm5
      >
        <v-textarea
          v-model="form.other_lpr"
          filled
          name="Autre LPPR :"
          label="Autre LPPR :"
        />
      </v-flex>
    </v-layout>

    <v-layout
      justify-space-between
      mt-8
    >
      <v-flex
        v-for="(section, prop, index) in groupedArticles"
        :key="index"
        column
        sm6
      >
        <h2>{{ prop }}</h2>
        <v-layout
          v-for="(article) in section"
          :key="article.article_id"
          class="checkbox-input-container"
        >
          <v-flex>
            <v-checkbox
              v-model="form.articles[article.index].idc_want"
              hide-details
              @change="handleCheckbox($event, article.index)"
            >
              <template v-slot:label>
                <h4>{{ article.article_reference }}</h4>
                <h4>{{ article.label }}</h4>
              </template>
            </v-checkbox>
          </v-flex>
          <v-flex class="checkbox-input">
            <InputNumber
              v-if="article.idc_entry"
              v-model="form.articles[article.index].value"
              :disable="!form.articles[article.index].idc_want"
              class="input-number"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { articles } from "@/mixins/articles";
import InputNumber from "../../../../components/InputNumber";

export default {
  name: "UpperLimbOrthosisStepTwo",
  components: { InputNumber },
  mixins: [articles],
  props: {
    form: {
      type: Object,
      required: true,
    },
  },

  async created() {
    await this.loadArticles("UPPER_LIMB_ORTHOSIS", true);

    if (this.form.articles.length <= 0) {
      this.form.articles = this.articles;
    }
  },

  methods: {
    // Set value to null if option is not checked
    handleCheckbox(e, article_index) {
      if (!e) {
        this.form.articles[article_index].value = null;
      } else {
        this.form.articles[article_index].value = 1;
      }
    },
  },
};
</script>

<style lang="scss">
.upper-limb-orthosisW-step-two {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        //height: 100%;
        //width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 10.1%;
        height: 8.6%;
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: 80px !important;
        &:not(.visible) {
          // display: none;
        }
      }
    }
  }

  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      overflow: hidden;
      margin-bottom: 15px;
      .v-label {
        align-items: baseline;
      }
    }
  }
}
</style>
